module.exports = __webpack_public_path__ + "static/Tiramisu-77e9696dc72f57ea3a56e4cff96ee116.png";